class AnnouncementBar extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.slider = null;
    this.initSlider();
    window.addEventListener('resize', this.debounce(this.initSlider.bind(this), 200));
  }

  initSlider() {
    const isMobileDevices = window.matchMedia('(max-width: 989px)').matches;
    if (this.slider && !isMobileDevices) {
      this.slider.destroy();
      this.slider = null;
    }

    if (!this.querySelector('.swiper')) return;

    this.options = {
      slidesPerView: 1,
      draggable: true,
      loop: true,
      autoplay: {
        delay: this.dataset.sliderAutoplaySpeed
      }
    };

    if (isMobileDevices) {
      this.slider = new Swiper(
        this.querySelector('.swiper'),
        this.options
      );
    }
  }

  debounce(mainFunction, delay) {
    let timer;

    return function (...args) {
      clearTimeout(timer);

      timer = setTimeout(() => {
        mainFunction(...args);
      }, delay);
    }
  }
}

customElements.define('announcement-bar', AnnouncementBar);
